export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";